<template>
  <div class="consultation-details-highlight">
    <div
      v-for="detail in highlightedDetails"
      :key="detail.key"
      v-html="detail.html"
    />
  </div>
</template>

<script>
import { buildConsultationDetailsHighlight } from "@/vue/utils/consultationExtractedQuestionsHighlight";

export default {
  name: "ConsultationDetailsHighlightedWithExtractedQuestions",
  props: {
    consultationDetails: {
      type: Object,
      default: () => ({}),
    },
    extractedQuestions: {
      type: Array,
      default: () => [],
    },
    selectedQuestionId: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    highlightedDetails() {
      return buildConsultationDetailsHighlight({
        consultationDetails: this.consultationDetails,
        extractedQuestions: this.extractedQuestions,
        selectedQuestionId: this.selectedQuestionId,
      });
    },
  },
};
</script>

<style lang="scss">
.consultation-details-highlight {
  .overlay-editor__underline {
    position: relative;
  }

  .overlay-editor__underline--ai {
    .overlay-editor__underline-text {
      border-bottom: 2px dotted #ccc;
    }

    &--selected {
      .overlay-editor__underline-text {
        background-color: #ffecef;
      }
    }
  }

}
</style>
